import { get } from "lodash";
import {
  Avatar,
  Flex,
  FlexItem,
  Small,
  StyledLink,
  Divider,
  Badge,
} from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";

import AvatarPlaceholder from "src/components/Placeholder/AvatarPlaceholder";
import URL, { url } from "src/consts/urlPaths";
import * as searchUtil from "src/util/search";
import { getTagTypeName } from "src/util/tags";
import { useWorkspaceTagConfig } from "src/contexts/global/WorkspaceContext";

const TagListItem = ({ tag, loading, isLastItem, selectedString }) => {
  const tagTypesConfig = useWorkspaceTagConfig();
  const tagId = get(tag, "id");

  const groupName = tagId && (
    <StyledLink
      to={url(URL.TAG_DETAILS, { id: tagId })}
      display="block"
      width="100%"
    >
      {searchUtil.highlightSelectedString(tag.displayValue, selectedString)}
    </StyledLink>
  );

  let itemDivider = null;
  if (!isLastItem) {
    itemDivider = <Divider light />;
  }

  const tagTypeName = getTagTypeName(tag.type, tagTypesConfig);

  return loading ? (
    <AvatarPlaceholder rows={1} />
  ) : (
    <>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        flexWrap="nowrap"
        py="s"
      >
        <Avatar
          data-testid="cp-explore-team-list-item-panel"
          shape="tag"
          sizing="small"
          title={groupName}
          subtitle={<Badge my="xs">{tagTypeName}</Badge>}
          type="default"
        />
        {tag?.appliedCount != null && (
          <FlexItem flex="0 0 auto">
            <Small color="subText">{`${tag.appliedCount} tagged`}</Small>
          </FlexItem>
        )}
      </Flex>
      {itemDivider}
    </>
  );
};

TagListItem.propTypes = {
  tag: PropTypes.object, // number for placeholder
  loading: PropTypes.bool,
  isLastItem: PropTypes.bool,
  selectedString: PropTypes.string,
};

export default TagListItem;
